import React, { FC }             from 'react';
import moment, { Moment }        from 'moment';
import { Label, LabelProps }     from 'semantic-ui-react';
import { TimeService }           from '../../../services/TimeService';
import { EMPTY_VALUE_DISPLAY }   from '../../../constants/FormatStringEnums';
import { formatDateRangeString } from '../../../util';

interface Props {
	// Start date to use for the range
	startDate: Moment,

	// End date to use for the range
	endDate: Moment,

	// Whether to show the relative or exact language for the summary label; hides range labels when used.
	relativeLanguage?: boolean,

	// Show the humanized language as a label?
	withSummaryLabel?: boolean,

	// Show the date range labels?
	withRangeLabels?: boolean,

	// Combine the range into one label?
	singleLabel?: boolean,

	// Combined label Semantic props
	singleLabelProps?: LabelProps,

	// To label Semantic props
	toLabelProps?: LabelProps,

	// From label Semantic props
	fromLabelProps?: LabelProps,
}

const defaultProps: Props = {
	startDate:        null,
	endDate:          null,
	relativeLanguage: null,
	withSummaryLabel: true,
	withRangeLabels:  true,
	singleLabel:      false,
	singleLabelProps: {},
	toLabelProps:     {},
	fromLabelProps:   {},
}

const HumanizedDateRangeLabel: FC<Props> = ( props ) => {

	let { startDate, endDate }                = props,
	    { relativeLanguage }                  = props,
	    { singleLabel, singleLabelProps }     = props,
	    { withSummaryLabel, withRangeLabels } = props,
	    hasDates                              = !( !startDate || !endDate ),
	    humanizedStart,
	    humanizedEnd,
	    humanizedRange,
	    isUpcoming,
	    summaryLabel;

	if( hasDates ){
		humanizedStart = TimeService.getHumanizedDays( startDate );
		humanizedEnd   = TimeService.getHumanizedDays( endDate );
		humanizedRange = TimeService.getHumanizedDays( endDate, startDate, false, true );
		isUpcoming     = moment().isBefore( startDate );
	}

	if( relativeLanguage ){
		summaryLabel = `${ humanizedRange }`
	} else {
		summaryLabel = isUpcoming ? `Starts ${ humanizedStart }` : `Ends ${ humanizedEnd }`
	}

	return (
		<>
			{ hasDates ? (
				<>
					{ withSummaryLabel && <Label circular color={ 'purple' } content={ summaryLabel }/> }
					{ withRangeLabels && !relativeLanguage && (
						<>
							{ withSummaryLabel &&
							<span className={ 'display--inline-block margin-xs-right' }>:</span> }

							{ singleLabel ? (
								<>
									<Label circular basic icon={ { name: 'calendar alternate outline' } }
									       content={ `${ formatDateRangeString( TimeService.asDisplayDate( startDate ), TimeService.asDisplayDate( endDate ) ) }` }
									       { ...props.singleLabelProps }
									/>
								</>
							) : (
								  <>
									  { withSummaryLabel &&
									  <span className={ 'display--inline-block margin-xs-right' }>:</span> }
									  <Label circular basic icon={ { name: 'calendar alternate outline' } } content={ TimeService.asDisplayDate( startDate ) } { ...props.fromLabelProps }/>
									  <span className={ 'display--inline-block margin-xs-horizontal' }>to</span>
									  <Label circular basic icon={ { name: 'calendar alternate outline' } } content={ TimeService.asDisplayDate( endDate ) } { ...props.toLabelProps }/>
								  </>
							  ) }
						</>
					) }
				</>
			) : ( EMPTY_VALUE_DISPLAY ) }
		</>
	)
};

HumanizedDateRangeLabel.defaultProps = defaultProps;

export { HumanizedDateRangeLabel }
